<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button></ion-back-button>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button v-if="!newReview" @click="deleteReview"><ion-icon :icon="trash"/></ion-button>
        </ion-buttons>
        <ion-title><HomeButton/> {{ t(title) }}</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list lines="full">
        <ion-item>
          <ion-label position="floating">{{ t('form.review.description') }}</ion-label>
          <ion-textarea @ionChange="editReview.description=$event.target.value"
                        :value="editReview.description"></ion-textarea>
        </ion-item>
        <ion-list-header v-if="editReview.tasks.length">{{ t('form.review.tasks',{num:editReview.tasks.length}) }}</ion-list-header>
        <ion-list-header v-if="!editReview.tasks.length">{{ t('form.review.notasks') }}</ion-list-header>
        <TaskItem v-for="task in relatedTasks" v-bind:key="task.id" :task="task" :readOnly="true"/>

      </ion-list>

      <ion-button @click="cancel">{{ t("form.buttons.cancel") }}</ion-button>
      <ion-button @click="save">{{ t("form.buttons.ok") }}</ion-button>

    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import TaskItem from "@/components/TaskItem.vue";
import {createEmptyReview, Review, TaskUtils} from '@/store/state';
import {
  IonContent,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonTitle,
  IonLabel,
  IonList,
  IonItem,
  IonTextarea,
  IonButton,
  IonPage,
    IonIcon
} from "@ionic/vue";
import {NavigationGuardNext, RouteLocationNormalized, useRouter, useRoute} from "vue-router";
import {useI18n} from "vue-i18n";
import {watch,ref} from "vue";
import {Task, createEmptyTask} from "@/store/state";
import {useStore} from "@/store/store";
import firebase from "firebase";
import {trash} from "ionicons/icons";
import Timestamp = firebase.firestore.Timestamp;
import HomeButton from "@/components/HomeButton.vue";

const translations = {
  de: {
    titleNew: "Neues Review",
    titleEdit: "Review Bearbeiten",
    datetimeFormat: 'D.M.YY H:m',

    form: {
      buttons: {
        ok: "Speichern",
        cancel: "Abbrechen"
      },
      review: {
        description: "Beschreibung",
        tasks: "zugehörige Aufgaben ({num})",
        notasks: "Diesem Review sind keine Aufgaben zugeordnet"
      },
    }
  }
}

export default defineComponent({
  name: "TaskForm",
  components: {
    HomeButton,
    TaskItem,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonBackButton,
    IonTitle,
    IonContent,
    IonLabel,
    IonList,
    IonItem,
    IonTextarea,
    IonButton,
    IonPage
  },
  props: {
    taskId: {
      type: String,
      required: false,
    }
  },
  data() {
    return {}
  },
  computed: {
    title(): string {
      if (this.newReview) {
        return "titleNew"
      } else {
        return "titleEdit"
      }

      //
    },
    relatedTasks(): Task[]{
      console.log("get related tasks",this.editReview.tasks,this.store.state.tasks);

      return this.store.state.tasks.filter(t => this.editReview.tasks.includes(t.id))
    },
    current(): Review | undefined{
      return this.store.state.reviews.filter(t=>t.id===this.editReview.id).pop();
    }
  },
  methods: {
    asDate(t: Date|Timestamp|null): Date{
      return TaskUtils.asDate(t)
    },
    cancel(){
      this.router.go(-1)
    },
    toReviews() {
      // this.router.go(-1);
      this.router.push({name:'Reviews'})
    },
    async save() {

      if (this.newReview) {
        await this.store.dispatch('addReview',this.editReview).then(_=>this.toReviews())
      } else {
        await this.store.dispatch('updateReview',{n:this.editReview,o:this.current}).then(_=>this.toReviews())
      }
      this.$forceUpdate();

    },
    async deleteReview() {
      console.log("deleting");
      await this.store.dispatch('deleteReview',{id:this.editReview.id,tasks:this.editReview.tasks})
      this.toReviews()

    },
    loadReview(id: string | null) {

      if (id) {

        const filtered = this.store.state.reviews.filter((t: Review) => t.id === id)
        if (filtered.length) {

          this.editReview = filtered.pop() ?? this.editReview;
          //clone!
          this.editReview = {...this.editReview};
          this.newReview = false;
        }
      } else {
        this.newReview = true
        this.editReview = createEmptyReview(this.editReview.tasks)
        console.log("created edit review",this.editReview);

      }

    }

  },

  watch:{
    realReviewId: {
      handler(n: string, o: string) {
        console.log("watch handled",n);
          this.loadReview(n)
      },
      immediate: true
    }
  },
  setup(props) {

    const router = useRouter();
    const {t, locale} = useI18n({messages: translations})
    const store = useStore();

    //scheiss workaround, bis das routing richtig funktioniert
    const route = useRoute();
    console.log('params',route.params);
    const realReviewId = route.params['reviewId'];
    const tasksString: string | string[]  = route.params['tasks']??""

    let tasks: string[] = []
    if(typeof tasksString == "string") tasks = tasksString.split(",")
    else tasks = tasksString
    console.log("tasks",tasks,realReviewId);
    const editReview: Review = createEmptyReview(tasks);
    const newReview = true;
    // watch(ref(props.taskId), (first, second) => {
    //   console.log("watch",first,second);
    //       loadTask(first);
    //     },
    //     {immediate: true}
    // );

    return {
      t,
      locale,
      router,
      store,
      editReview,
      newReview,
      realReviewId,
      trash
    }
  }
})
</script>

<style scoped>

</style>